/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * See https://stackoverflow.com/questions/38241480/detect-macos-ios-windows-android-and-linux-os-with-js
 */

const _window: Window = globalThis.window || ({} as Window);

export enum OS_NAME {
	UNKNOWN = "unknown",
	WINDOWS = "win",
	LINUX = "linux",
	MACOS = "mac",
	IOS = "ios",
	ANDROID = "android"
}

const macosPlatforms = [ "Macintosh", "MacIntel", "MacPPC", "Mac68K" ];
const windowsPlatforms = [ "Win32", "Win64", "Windows", "WinCE" ];
const iosPlatforms = [ "iPhone", "iPad", "iPod" ];

/**
 * Tries to detect the operating system
 */
export function detectOperatingSystem(): OS_NAME {
	const ua = _window.navigator?.userAgent;
	const platform = _window.navigator?.platform;

	if (macosPlatforms.indexOf(platform) !== -1) {
		return OS_NAME.MACOS;
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		return OS_NAME.IOS;
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		return OS_NAME.WINDOWS;
	} else if (/Android/.test(ua)) {
		return OS_NAME.ANDROID;
	} else if (/Linux/.test(platform)) {
		return OS_NAME.LINUX;
	} else {
		return OS_NAME.UNKNOWN;
	}
}
